import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef, useCallback } from 'react';
import Modal from 'react-modal';
import { getApi, postApi, putApi } from '../../services/apiServices';
import { toast } from 'react-toastify';

function UserManagement() {
  const dropdownRef = useRef(null);
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  const [isBlocking, setIsBlocking] = useState(false);
  const [isRestoreModalOpen, setIsRestoreModalOpen] = useState(false);
  const [isRestoring, setIsRestoring] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalAction, setModalAction] = useState('block'); // 'block' or 'unblock'
  console.log(selectedUser, "selectedUser");  
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedUserForDropdown, setSelectedUserForDropdown] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    search: '',
    status: '',
    verified: '',
    location: ''
  });

  const [activeTab, setActiveTab] = useState('all'); 
  const [verifiedDropdown, setVerifiedDropdown] = useState(false);
  const [verifiedSearchTerm, setVerifiedSearchTerm] = useState('');

  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
   
    setFilters(prev => ({
      ...prev,
      status: ''
    }));
  };

  const handleVerifiedSelection = (value) => {
    handleFilterChange('verified', value);
    setVerifiedDropdown(false);
    setVerifiedSearchTerm('');
  };

  const verifiedOptions = [
    { id: '1', name: 'Yes' },
    { id: '0', name: 'No' }
  ];

  const filteredVerifiedOptions = verifiedOptions.filter(option =>
    option.name.toLowerCase().includes(verifiedSearchTerm.toLowerCase())
  );

  const getVerifiedDisplayText = () => {
    if (filters.verified) {
      const selectedOption = verifiedOptions.find(v => v.id === filters.verified);
      return selectedOption ? selectedOption.name : 'Verified User';
    }
    return 'Verified User';
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setFilters(prev => ({
      ...prev,
      search: value
    }));
  };

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams();
      if (filters.search) params.append('search', filters.search);
      if (filters.status) params.append('status', filters.status);
      if (filters.verified) params.append('verified', filters.verified);
      if (filters.location) params.append('location', filters.location);
      if (activeTab === 'active') {
        params.append('status', '1');
      } else if (activeTab === 'blocked') {
        params.append('status', '2');
      } else if (activeTab === 'deleted') {
        params.append('status', '3');
      }

      const url = `users?${params.toString()}`;
      const response = await getApi(url);

      if (response?.statusCode === 200) {
        setUsers(response.data || []);
      } else {
        setError(response?.message || 'Failed to fetch users');
        console.error('Failed to fetch users:', response?.message);
      }
    } catch (error) {
      setError('Error fetching users. Please try again.');
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }, [filters.search, filters.status, filters.verified, filters.location, activeTab]);

  useEffect(() => {
    if (filters.search !== '') {
      const timeoutId = setTimeout(() => {
        fetchUsers();
      }, 500);
      return () => clearTimeout(timeoutId);
    }

    fetchUsers();
  }, [filters.search, filters.status, filters.verified, filters.location, activeTab, fetchUsers]);

  const openBlockModal = (e, user, action = 'block') => {
    e.preventDefault();
    setSelectedUser(user);
    setModalAction(action);
    setIsBlockModalOpen(true);
  };

  const closeBlockModal = () => {
    setIsBlockModalOpen(false);
    setSelectedUser(null);
    setModalAction('block');
  };

  const openRestoreModal = (e, user) => {
    e.preventDefault();
    setSelectedUser(user);
    setIsRestoreModalOpen(true);
  };

  const closeRestoreModal = () => {
    setIsRestoreModalOpen(false);
    setSelectedUser(null);
  };

  const openDeleteModal = (e, user) => {
    e.preventDefault();
    setSelectedUser(user);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedUser(null);
  };


  const toggleDropdown = (e, user) => {
    e.preventDefault();
    e.stopPropagation();
    if (isDropdownOpen && selectedUserForDropdown?.id === user.id) {
      setIsDropdownOpen(false);
      setSelectedUserForDropdown(null);
    } else {
      setIsDropdownOpen(true);
      setSelectedUserForDropdown(user);
    }
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
    setSelectedUserForDropdown(null);
  };

  const handleBlock = async () => {
    if (!selectedUser) return;

    setIsBlocking(true);
    try {
      const isUnblockAction = modalAction === 'unblock';
      const status = isUnblockAction ? "1" : "2";
      const successMessage = isUnblockAction ? 'User unblocked successfully!' : 'User blocked successfully!';
      const errorMessage = isUnblockAction ? 'Failed to unblock user. Please try again.' : 'Failed to block user. Please try again.';

      const response = await postApi('/block-user', {
        user_id: selectedUser.id,
        status: status
      });

      if (response?.statusCode === 200) {
        setIsBlockModalOpen(false);
        setSelectedUser(null);
        setModalAction('block');
        await fetchUsers(); 
        toast.success(successMessage);
      } else {
        console.error(`Failed to ${modalAction} user:`, response?.message);
        toast.error(response?.message || errorMessage);
      }
    } catch (error) {
      console.error(`Error ${modalAction}ing user:`, error);
      toast.error(`Error ${modalAction}ing user. Please try again.`);
    } finally {
      setIsBlocking(false);
    }
  };

  const handleRestore = async () => {
    if (!selectedUser) return;

    setIsRestoring(true);
    try {
      console.log('Selected user:', selectedUser);
      console.log('User ID:', selectedUser.id);

      // Validate that we have user ID
      if (!selectedUser.id) {
        toast.error('No user ID found for this user');
        setIsRestoring(false);
        return;
      }

      const response = await postApi('/restore-account', {
        user_id: selectedUser.id
      });

      if (response?.statusCode === 200) {
        setIsRestoreModalOpen(false);
        setSelectedUser(null);
        await fetchUsers(); 
        toast.success('Account restored successfully!');
      } else {
        console.error('Failed to restore account:', response?.message);
        toast.error(response?.message || 'Failed to restore account. Please try again.');
      }
    } catch (error) {
      console.error('Error restoring account:', error);
      toast.error('Error restoring account. Please try again.');
    } finally {
      setIsRestoring(false);
    }
  };

  const handleDelete = async () => {
    if (!selectedUser) return;

    setIsDeleting(true);
    try {
      console.log('Selected user:', selectedUser);
      console.log('User ID:', selectedUser.id);

      // Validate that we have user ID
      if (!selectedUser.id) {
        toast.error('No user ID found for this user');
        setIsDeleting(false);
        return;
      }

      const response = await putApi('/soft-delete', {
        user_id: selectedUser.id
      });

      if (response?.statusCode === 200) {
        setIsDeleteModalOpen(false);
        setSelectedUser(null);
        await fetchUsers(); 
        toast.success('User deleted successfully!');
      } else {
        console.error('Failed to delete user:', response?.message);
        toast.error(response?.message || 'Failed to delete user. Please try again.');
      }
    } catch (error) {
      console.error('Error deleting user:', error);
      toast.error('Error deleting user. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };


  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '560px',
      borderRadius: '8px',
      padding: '20px',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000,
    },
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setVerifiedDropdown(false);
      }
      // Close action dropdown when clicking outside
      if (isDropdownOpen) {
        // Check if the click is not inside any dropdown
        const isInsideDropdown = event.target.closest('.action-dropdown');
        if (!isInsideDropdown) {
          closeDropdown();
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);
  return (
    <>
      <div className="right-section">
        <div className="customer-top">
          <div className="customer-top-left">
            <ul>
              <li><a href="#" className={activeTab === 'all' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleTabChange('all'); }}>All</a></li>
              <li><a href="#" className={activeTab === 'active' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleTabChange('active'); }}>Active</a></li>
              <li><a href="#" className={activeTab === 'blocked' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleTabChange('blocked'); }}>Blocked</a></li>
              <li><a href="#" className={activeTab === 'deleted' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleTabChange('deleted'); }}>Deleted</a></li>
            </ul>
          </div>

          <div className="customer-top-right">
            <div className="select-option" ref={dropdownRef}>
              <div className="selctions-option position-relative">
                <div
                  className={`dropdown-cs ${verifiedDropdown ? 'before-change-cs' : ''}`}
                  onClick={() => {
                    setVerifiedDropdown(!verifiedDropdown);
                    setVerifiedSearchTerm('');
                  }}
                >
                  {getVerifiedDisplayText()}
                </div>

                {verifiedDropdown && (
                  <div className="select-dropdown w-100">
                    <ul>
                      <li
                        className="dropdown-item-clear"
                        onClick={() => handleVerifiedSelection('')}
                      >
                        <input
                          type="checkbox"
                          checked={!filters.verified}
                          onChange={() => handleVerifiedSelection('')}
                        />
                        <span>All</span>
                      </li>
                      {filteredVerifiedOptions.length > 0 ? (
                        filteredVerifiedOptions.map(option => (
                          <li key={option.id} onClick={() => handleVerifiedSelection(option.id)}>
                            <input
                              type="checkbox"
                              checked={filters.verified === option.id}
                              onChange={() => handleVerifiedSelection(option.id)}
                            />
                            <span>{option.name}</span>
                          </li>
                        ))
                      ) : (
                        <li className="no-data-available">No options available</li>
                      )}
                    </ul>
                  </div>
                )}
              </div>
            </div>


            <input
              type="text"
              className="search-input"
              placeholder="Search by name / email / phone"
              value={filters.search}
              onChange={handleSearchChange}
            />
          </div>
        </div>

        {loading && (
          <div className="loader-overlay">
            <span className="loader"></span>
          </div>
        )}

        <div className="customer-tablle-main">

          <table className="table">
            <thead>
              <tr>
                <th className="uid">Sr No</th>
                <th className="name" scope="col">Name</th>
                <th className="email" scope="col">Email</th>
                <th className="plan" scope="col">Plan</th>
                <th className="status" scope="col">Status</th>
                <th className="verified" scope="col">Verified</th>
                <th className="registered-on" scope="col">Registered On</th>
                <th className="action" scope="col">Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center py-4">
                    <div className="text-muted">Loading users...</div>
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="8" className="text-center py-4 text-danger">{error}</td>
                </tr>
              ) : users.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center py-4">No users found.</td>
                </tr>
              ) : (
                users.map((user, index) => (
                  <tr key={user.id || index}>
                    <td className="uid">{index + 1}</td>
                    <td className="name">
                      <div className="table-mails">
                        <span className="profile-img">
                          <img
                            src={
                              user.user_image ||
                              (Array.isArray(user.User_Images) && user.User_Images[0]?.image) ||
                              window.getPublicUrl("images/john.svg")
                            }
                            alt={user.full_name || "User"}
                          />
                        </span>
                        <div>
                          <h3>   {user.full_name || "N/A"}</h3>
                        </div>
                      </div>
                      {/* <span className="profile-img">
                        <img
                          src={
                            user.user_image ||
                            (Array.isArray(user.User_Images) && user.User_Images[0]?.image) ||
                            window.getPublicUrl("images/john.svg")
                          }
                          alt={user.full_name || "User"}
                        />
                      </span>
                      {user.full_name || "N/A"} */}
                    </td>
                    <td className={user.email ? "email" : "number-email"}>
                      <div>
                        <div>{user.email || ""}</div>
                        <div>{user.phone_number || ""}</div>
                      </div>
                    </td>

                    <td className="plan">-</td>
                    <td className="status">
                      {user.status === "2" ? (
                        <button className="btn btn-status btn-status-block">
                          <img src={window.getPublicUrl('/images/block-dots.svg')} alt="Block" />
                          Block
                        </button>
                      ) : user.status === "1" ? (
                        <button className="btn btn-status btn-status-primary">
                          <img src={window.getPublicUrl('/images/dot.svg')} alt="Active" />
                          Active
                        </button>
                      ) : user.status === "3" ? (
                        <button className="btn btn-status btn-status-block">
                          <img src={window.getPublicUrl('/images/block-dots.svg')} alt="Delete" />
                          Delete
                        </button>
                      ) : null}
                    </td>
                    <td>{(user.email_verify || user.phone_verify) ? 'Yes' : 'No'}</td>
                    <td>{user.createdAt ? new Date(user.createdAt).toLocaleDateString('en-GB', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    }) : "N/A"}</td>
                    <td className="action">
                      <div className="view-image position-relative">
                        <button className="btn" onClick={(e) => toggleDropdown(e, user)}>
                          <img src={window.getPublicUrl('/images/three_dot.svg')} alt="Actions" />
                        </button>
                        
                        {isDropdownOpen && selectedUserForDropdown?.id === user.id && (
                          <div 
                            className="action-dropdown"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <ul>
                              <li>
                                <Link 
                                  to={`/admin/viewUserManagement/${user.id || index}`} 
                                  onClick={closeDropdown}
                                >
                                  <img src={window.getPublicUrl('/images/view.svg')} alt="View" />
                                  <span>View</span>
                                </Link>
                              </li>
                              {user.status !== "2" && user.status !== "3" && (
                                <li>
                                  <button 
                                    onClick={(e) => { closeDropdown(); openBlockModal(e, user); }}
                                  >
                                    <img src={window.getPublicUrl('/images/block.svg')} alt="Block" />
                                    <span>Block</span>
                                  </button>
                                </li>
                              )}
                              {user.status === "2" && (
                                <li>
                                  <button 
                                    onClick={(e) => { closeDropdown(); openBlockModal(e, user, 'unblock'); }}
                                  >
                                    <img src={window.getPublicUrl('/images/unblock.svg')} alt="Unblock" />
                                    <span>Unblock</span>
                                  </button>
                                </li>
                              )}
                              {user.status === "3" && (
                                <li>
                                  <button 
                                    onClick={(e) => { closeDropdown(); openRestoreModal(e, user); }}
                                  >
                                    <img src={window.getPublicUrl('/images/restore.svg')} alt="Restore" />
                                    <span>Restore</span>
                                  </button>
                                </li>
                              )}
                              {user.status !== "3" && (
                                <li>
                                  <button 
                                    onClick={(e) => { closeDropdown(); openDeleteModal(e, user); }}
                                  >
                                    <img src={window.getPublicUrl('/images/cross.svg')} alt="Delete" />
                                    <span>Delete</span>
                                  </button>
                                </li>
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        isOpen={isBlockModalOpen}
        onRequestClose={closeBlockModal}
        style={customStyles}
        contentLabel="Block User Confirmation"
      >
        <div className="">
          <div className="modal-content">
            <div className="modal-header">
              <div className="block-img">
                <img src={window.getPublicUrl(`/images/${modalAction}.svg`)} className="img-fluid" alt={`${modalAction} icon`} />
              </div>
              <button type="button" onClick={closeBlockModal} className="close" data-dismiss="modal" aria-label="Close">
                <img src={window.getPublicUrl('/images/close-icon.svg')} alt="Close" />
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <h3>{modalAction === 'unblock' ? 'Unblock User' : 'Block User'}</h3>
                  <p>Are you sure you want to {modalAction === 'unblock' ? 'Unblock' : 'Block'} this Account ?</p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-cancel" data-dismiss="modal" onClick={closeBlockModal}>Cancel</button>
              <button type="button" className="btn btn-save" onClick={handleBlock} disabled={isBlocking}>
                {isBlocking ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {modalAction === 'unblock' ? 'Unblocking...' : 'Blocking...'}
                  </>
                ) : (
                  modalAction === 'unblock' ? "Unblock User" : "Block User"
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isRestoreModalOpen}
        onRequestClose={closeRestoreModal}
        style={customStyles}
        contentLabel="Restore Account Confirmation"
      >
        <div className="">
          <div className="modal-content">
            <div className="modal-header">
              <div className="block-img">
                <img src={window.getPublicUrl('/images/restore.svg')} className="img-fluid" alt="Restore icon" />
              </div>
              <button type="button" onClick={closeRestoreModal} className="close" data-dismiss="modal" aria-label="Close">
                <img src={window.getPublicUrl('/images/close-icon.svg')} alt="Close" />
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <h3>Restore Account</h3>
                  <p>Are you sure you want to Restore this Account ?</p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-cancel" data-dismiss="modal" onClick={closeRestoreModal}>Cancel</button>
              <button type="button" className="btn btn-save" onClick={handleRestore} disabled={isRestoring}>
                {isRestoring ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Restoring...
                  </>
                ) : (
                  "Restore Account"
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        style={customStyles}
        contentLabel="Delete User Confirmation"
      >
        <div className="">
          <div className="modal-content">
            <div className="modal-header">
              <div className="block-img">
                <img src={window.getPublicUrl('/images/cross.svg')} className="img-fluid" alt="Delete icon" />
              </div>
              <button type="button" onClick={closeDeleteModal} className="close" data-dismiss="modal" aria-label="Close">
                <img src={window.getPublicUrl('/images/close-icon.svg')} alt="Close" />
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <h3>Delete User</h3>
                  <p>Are you sure you want to Delete this Account ?</p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-cancel" data-dismiss="modal" onClick={closeDeleteModal}>Cancel</button>
              <button type="button" className="btn btn-save" onClick={handleDelete} disabled={isDeleting}>
                {isDeleting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Deleting...
                  </>
                ) : (
                  "Delete User"
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>

    </>
  );
}

export default UserManagement;